export default () => ({
  componentName: 'cell-service',
});
